// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { chain, UpdatePrice } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ChangeUnitOfMeasure";

/**
 * XNG-Changes: WEST-1054(Comment)
 * Issue:
 * When changing the UoM, there is a delay between the time the user changes the UoM and the actual UoM price is displayed.
 * For instance, if you change to BX, it will take a few seconds before the box price is show. In that few seconds, it shows the previous price (i.e. $3.00/ea, change UoM, it shows $3.00 / bx before changing to $30.00/bx).
 * Can we make it instead show the price as loading ($--.--) until the API call finishes?
 *
 * Solution:
 * Add isLoading step, the realTime takes a long time to update the price when change UOM
 */
export const XngIsLoadingPrice: typeof UpdatePrice = props => {
    const state = props.getState();
    const { productId } = props.parameter;
    const product = getProductState(state, productId).value;
    if (!product || product.quoteRequired) {
        return;
    }

    const { productInfosById } = state.pages.productDetails;
    if (!productInfosById) {
        return;
    }

    const productInfo = productInfosById[productId];
    if (!productInfo) {
        return;
    }

    props.dispatch({
        type: "Pages/ProductDetails/CompleteLoadRealTimePricing",
        pricing: {
            productId,
            properties: { isLoading: true },
        } as any,
    });
};

addToChainBefore(chain, UpdatePrice, XngIsLoadingPrice);
